module.exports = __webpack_public_path__ + "img/pt.f8a172f2.png";